import { render, staticRenderFns } from "./job-category.vue?vue&type=template&id=59081c3f&"
import script from "./job-category.vue?vue&type=script&lang=js&"
export * from "./job-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports